/**
 * Global Loading Manager
 *
 * Centralized utility to manage AJAX loading states across the entire site
 * All modules should use this instead of their own loading implementations
 *
 * @package Gravity
 * @since 1.0.0
 */

class LoadingManager {
  constructor() {
    this.$loadingOverlay = null;
    // Track concurrent requests
    this.activeRequests = 0;
    this.initialized = false;
  }

  /**
   * Initialize the loading overlay
   * Creates the overlay if it doesn't exist and appends to body
   */
  init() {
    if (this.initialized) {
      return;
    }

    // Check if overlay already exists
    this.$loadingOverlay = $('.global-loading-overlay');

    if (this.$loadingOverlay.length === 0) {
      // Create the overlay
      this.$loadingOverlay = $(`
        <div class="global-loading-overlay posts-loading fixed inset-0 hidden justify-center bg-white/30 z-50">
          <div class="posts-loading__content">
            <div class="posts-loading__spinner"></div>
          </div>
        </div>
      `);

      // Append to body
      $('body').append(this.$loadingOverlay);
    }

    this.initialized = true;
  }

  /**
   * Show loading overlay
   * Handles multiple concurrent requests by tracking active count
   */
  show() {
    if (!this.initialized) {
      this.init();
    }

    this.activeRequests++;

    // Only show if this is the first request
    if (this.activeRequests === 1) {
      this.$loadingOverlay.removeClass('hidden').addClass('flex');
    }
  }

  /**
   * Hide loading overlay
   * Only hides when all active requests are complete
   */
  hide() {
    if (!this.initialized) {
      return;
    }

    this.activeRequests = Math.max(0, this.activeRequests - 1);

    // Only hide when all requests are complete
    if (this.activeRequests === 0) {
      this.$loadingOverlay.removeClass('flex').addClass('hidden');
    }
  }

  /**
   * Force hide loading overlay
   * Resets counter and hides immediately (use carefully)
   */
  forceHide() {
    if (!this.initialized) {
      return;
    }

    this.activeRequests = 0;
    this.$loadingOverlay.removeClass('flex').addClass('hidden');
  }

  /**
   * Get current loading state
   * @returns {boolean} Whether loading is currently shown
   */
  isLoading() {
    return this.activeRequests > 0;
  }
}

// Create global singleton instance
window.LoadingManager = new LoadingManager();

export default window.LoadingManager;
